import { Injectable } from '@angular/core';
import { Headers, Http, Response} from '@angular/http';
import { User } from '../models/user';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import { environment } from '../../environments/environment';
import { ModalComponent } from '../modal/modal.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class AuthService {
	public model:any;
	isLogedin:boolean;
	private loginstatus = new BehaviorSubject<boolean>(false);
	currentLoginStatus = this.loginstatus.asObservable();

	private buttonClick = new Subject<string>();
	public buttonClick$ = this.buttonClick.asObservable().debounceTime(500);

	invokeClick(name: string){
		this.buttonClick.next(name);
	}


	private headers: Headers = new Headers({'Content-Type': 'application/json'});
	constructor(private http: Http, private modalService: NgbModal, private route: Router) {
		//code for autologout user after fixed time
		let myMoment: any = moment().format("X");
		let timestampExist : any = localStorage.getItem("timestamp");
		let tokenExist : any = localStorage.getItem("token");
		if(tokenExist){
			if(myMoment - timestampExist > 86400){
				this.logout();
				localStorage.setItem("timestamp",myMoment);
			}else{
				localStorage.setItem("timestamp",myMoment);
			}
		}else{
			//this.logout();
			localStorage.setItem("timestamp",myMoment);
		}
	}

  	changeLoginStatus(status: boolean) {
		let tokenExist = localStorage.getItem('token');
		if(tokenExist){
			this.loginstatus.next(status);
		}
	}
		
	login(user: User): Promise<any> {
		let url: string = `${environment.baseUrl}/login`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	logout(){
		this.changeLoginStatus(false);
		localStorage.removeItem('token');
		localStorage.removeItem('currentUser');
		localStorage.removeItem('sid');
		this.route.navigate(['/']);
	}

	register(user: User): Promise<any> {
		let url: string = `${environment.baseUrl}/sign_up`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}
	
	getarea(): Promise<any> {
		let url: string = `${environment.baseUrl}/active_area`;
		return this.http.get(url, {headers: this.headers}).toPromise();
	}
	
	paypal_accesstoken(): Promise<any> {
		let url: string = `${environment.baseUrl}/paypal_accesstoken`;
		return this.http.get(url, {headers: this.headers}).toPromise();
	}

	verifiysignup(data:any): Promise<any> {
		let url: string = `${environment.baseUrl}/verify_account`;
		return this.http.post(url, data, {headers: this.headers}).toPromise();
	}

	pricing(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/pricing`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	conetent(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/static_page`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	my_account(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/my_account`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	edit_profile(user: User): Promise<any> {
		let url: string = `${environment.baseUrl}/edit_profile`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	change_password(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/change_password`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	laundering_options(data?:any): Promise<any> {
		let url: string = `${environment.baseUrl}/laundering_options`;
    	return this.http.post(url, data, {headers: this.headers}).toPromise();
	}

	completed_order(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/userdOrderCompletedsList`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	pending_order(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/userdOrdersPendingList`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	booking_status_change(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/booking_status_change`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	booking_reschedule_change(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/booking_order_reschedule`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	booking_review(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/booking_review`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	order_limit_data(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/order_limit_data`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	add_booking(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/add_booking`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	forgot_password(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/forgot_password`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}

	mypayment(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/mypayment`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	} 

	card_save(card: any) {
		let url: string = `${environment.baseUrl}/payflow_auth`;
		return this.http.post(url, card, {headers: this.headers}).toPromise();  
	}

	card_update(order: any): Promise<any> {
		let url: string = `${environment.baseUrl}/card_update`;
		return this.http.post(url, order, {headers: this.headers}).toPromise();
	}
	
	card_save1(card: any) {
		let header = new Headers();
		header.append("content-type", 'application/x-www-form-urlencoded'); 
		header.append("Access-Control-Allow-Origin", '*');  
		let data = Object.assign({}, ...card, { "VENDOR": environment.paypalPayFlow.VENDOR, "USER": environment.paypalPayFlow.USER, "PARTNER": environment.paypalPayFlow.PARTNER, "PWD": environment.paypalPayFlow.PWD, "TRXTYPE":"A", "TENDER":"C", "AMT":'0.00', "CURRENCY":"USD"})
		console.log("data",data)
		let url: string = `${environment.paypalPayFlow.URL}`;
		 return this.http.post(url, this.toQueryStringNew(data), {headers: header})
		 .map((response1: Response) => this.successAPIPaypalPayFlowPro(response1))
		 .catch((error: any) => this.errorAPIPaypalPayFlowPro(error) );

	}

	card_info(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/card_info`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	} 
	reset_password(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/reset_password`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}
	check_reset_password(user: any): Promise<any> {
		let url: string = `${environment.baseUrl}/check_reset_password`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}
	driver_reset_password(user: any): Promise<any> {
		let url: string = `${environment.driverbaseUrl}/reset_password`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}
	check_driver_reset_password(user: any): Promise<any> {
		let url: string = `${environment.driverbaseUrl}/check_reset_password`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}

	sendcontactus(user: any): Promise<any> {
		console.log("fdfdf", user);
		let url: string = `${environment.baseUrl}/send_contact_email`;
		return this.http.post(url, user, {headers: this.headers}).toPromise();
	}
  //****************NgBootstrap Model */
	close(){
		if(this.model != undefined)
		this.model.close();
	}
	open(title, redirect = "", data= {}, button1 = "Ok", button2 = "") {
	   this.close();
	   this.model = this.modalService.open(ModalComponent, { windowClass: 'signup-error-popup' });
	   this.model.componentInstance.title = title;
	   this.model.componentInstance.model = this.model;
	   this.model.componentInstance.redirect = redirect;
	   this.model.componentInstance.data = data;
	   this.model.componentInstance.button1 = button1;
	   this.model.componentInstance.button2 = button2;
	   
	}

	public toQueryStringNew(obj) {
        var parts = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
            }
        }
        return ( parts.length > 0 ) ? (  parts.join("&")  ) : '';
	}
	
	public successAPIPaypalPayFlowPro(res) {
		// alert('success main' + JSON.stringify(res) );

		 let resSTR = JSON.stringify(res);
		 let resJSON = JSON.parse(resSTR);
		 
		 return this.queryStringToJSON(resJSON._body); 
	 }

	 public errorAPIPaypalPayFlowPro(error){ 
		console.log("error",error);
        return error;
    }

	public queryStringToJSON(queryString) {
		console.log("queryString",queryString)
		var pairs = (queryString).split('&');
		var result = {};
		pairs.forEach(function(pair) {
		  pair = pair.split('=');
		  result[pair[0]] = decodeURIComponent(pair[1] || '');
		});
		return result;
	  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/providers/auth.service.ts